import { Page } from '../types'

export type ContainerOrchestrationProps = { }

const render = () => {
    return <>
        <div>TODO Describe `docker-compose` or `Kubernetes` using `Dockerfile` images created in earlier steps</div>
    </>
}

const ContainerOrchestration : Page<ContainerOrchestrationProps> = {
    key: 'container-orchestration', 
    title: 'Setup container orchestration', 
    render
}

export default ContainerOrchestration